module.exports = __webpack_public_path__ + "img/domestic-2000-media50.2b52594b.jpg";